import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Full-page loading fallback for lazy-loaded routes.
 * Mirrors the DashboardLayout shape (sidebar + top bar + content)
 * so the transition from loading to loaded feels seamless.
 *
 * Used as: <Suspense fallback={<RouteLoadingFallback />}>
 */
const RouteLoadingFallback = () => (
  <div className="min-h-screen bg-background">
    {/* Desktop sidebar skeleton — hidden on mobile */}
    <div className="hidden lg:block fixed inset-y-0 left-0 w-64 border-r border-border bg-card">
      <div className="p-6 space-y-6">
        {/* Logo placeholder */}
        <Skeleton className="h-8 w-36" />

        {/* Nav items */}
        <div className="space-y-3 pt-4">
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} className="h-9 w-full rounded-lg" />
          ))}
        </div>
      </div>
    </div>

    {/* Main content area */}
    <div className="lg:ml-64 min-h-screen">
      {/* Desktop top bar skeleton — hidden on mobile */}
      <div className="hidden lg:block sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-sm">
        <div className="flex items-center justify-end gap-3 px-8 py-3">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-8 w-24 rounded-lg" />
        </div>
      </div>

      {/* Mobile header skeleton — visible only on mobile */}
      <div className="lg:hidden sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-sm px-4 py-3">
        <Skeleton className="h-7 w-32" />
      </div>

      {/* Centered spinner in the content area */}
      <div className="flex items-center justify-center py-32">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-label="Loading page" />
      </div>
    </div>
  </div>
);

export default RouteLoadingFallback;
